module.exports = __webpack_public_path__ + "static/Approach-68b27c2d13872bf1b5dcddcb2050f735.png";